import { BlockSchemaExtension } from '@blocksuite/store';

import { createEmbedBlockSchema } from '../../../utils/index.js';
import {
  type EmbedVideoBlockProps,
  EmbedVideoModel,
  EmbedVideoStyles,
} from './video-model.js';

const defaultEmbedVideoProps: EmbedVideoBlockProps = {
  style: EmbedVideoStyles[0],
  url: '',
  caption: null,

  image: null,
  title: null,
  description: null,
  creator: null,
  creatorUrl: null,
  creatorImage: null,
  aspectRatio: null,
  poster: null,
  videoId: null,
};

export const EmbedVideoBlockSchema = createEmbedBlockSchema({
  name: 'video',
  version: 1,
  toModel: () => new EmbedVideoModel(),
  props: (): EmbedVideoBlockProps => defaultEmbedVideoProps,
});

export const EmbedVideoBlockSchemaExtension = BlockSchemaExtension(
  EmbedVideoBlockSchema
);
